function addBusinessDays(startDate, businessDaysToAdd) {
  const date = new Date(startDate);
  let addedDays = 0;

  while (addedDays < businessDaysToAdd) {
    date.setDate(date.getDate() + 1);

    const dayOfWeek = date.getDay();
    const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;

    if (!isWeekend) {
      addedDays++;
    }
  }

  return date;
}

function formatPromiseDate(date) {
  return date.toLocaleDateString('en-CA', {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  });
}

function calculatePromiseRange(minBusinessDays, maxBusinessDays) {
  const today = new Date();

  const minDate = addBusinessDays(today, Number(minBusinessDays));
  const maxDate = addBusinessDays(today, Number(maxBusinessDays));

  return {
    minDate,
    maxDate,
    label: `${formatPromiseDate(minDate)} – ${formatPromiseDate(maxDate)}`
  };
}

function getSelectedVariantId(productForm) {
  const variantInput = productForm.querySelector('[name="id"]');
  return variantInput ? variantInput.value : null;
}

function getSelectedVariantOosData(productForm) {
  const variantId = getSelectedVariantId(productForm);

  if (!variantId || !window.KRAVE_OOS_VARIANT_DATA) {
    return null;
  }

  return window.KRAVE_OOS_VARIANT_DATA[variantId] || null;
}

function shouldAddOosPromise(variantData) {
  if (!variantData) return false;

  const inventoryQuantity = Number(variantData.inventoryQuantity);
  const inventoryPolicy = variantData.inventoryPolicy;

  const hasPromiseDays =
    Number(variantData.minBusinessDays) > 0 &&
    Number(variantData.maxBusinessDays) > 0;

  const isOutOfStock = inventoryQuantity <= 0;
  const canContinueSelling = inventoryPolicy === 'continue';

  return hasPromiseDays && isOutOfStock && canContinueSelling;
}

function removeExistingKravePromiseInputs(productForm) {
  productForm
    .querySelectorAll('[data-krave-oos-promise-input]')
    .forEach((input) => input.remove());
}

function appendLineItemProperty(productForm, name, value) {
  const input = document.createElement('input');

  input.type = 'hidden';
  input.name = `properties[${name}]`;
  input.value = value;
  input.setAttribute('data-krave-oos-promise-input', 'true');

  productForm.appendChild(input);
}

function getProductSubmitButton(productForm) {
  return productForm.querySelector(
    'button[type="submit"], [name="add"], .product-form__submit'
  );
}

function setProductButtonForOosPromise(productForm, shouldEnable) {
  const submitButton = getProductSubmitButton(productForm);

  if (!submitButton) {
    return;
  }

  const buttonTextElement = submitButton.querySelector('span') || submitButton;

  if (shouldEnable) {
    submitButton.disabled = false;
    submitButton.removeAttribute('disabled');
    submitButton.setAttribute('aria-disabled', 'false');
    submitButton.classList.remove('disabled');

    buttonTextElement.textContent = 'Pre-Order / Backorder';
  }
}

function updateKraveOosPromiseDisplay() {
  const productForm = document.querySelector('form[action*="/cart/add"]');
  const promiseWrapper = document.querySelector('.krave-oos-promise');
  const promiseDateElement = document.querySelector('[data-krave-oos-promise-date]');

  if (!productForm || !promiseWrapper || !promiseDateElement) {
    return;
  }

  const variantData = getSelectedVariantOosData(productForm);

  if (!shouldAddOosPromise(variantData)) {
    promiseWrapper.style.display = 'none';
    promiseDateElement.textContent = '';
    return;
  }

  const promiseRange = calculatePromiseRange(
    variantData.minBusinessDays,
    variantData.maxBusinessDays
  );

  promiseDateElement.textContent = promiseRange.label;
  promiseWrapper.style.display = 'block';

  setProductButtonForOosPromise(productForm, true);
}

document.addEventListener('submit', function(event) {
  const productForm = event.target.closest('form[action*="/cart/add"]');

  if (!productForm) {
    return;
  }

  removeExistingKravePromiseInputs(productForm);

  const variantData = getSelectedVariantOosData(productForm);

  if (!shouldAddOosPromise(variantData)) {
    return;
  }

  const promiseRange = calculatePromiseRange(
    variantData.minBusinessDays,
    variantData.maxBusinessDays
  );

  appendLineItemProperty(
    productForm,
    'Expected delivery',
    promiseRange.label
  );

  appendLineItemProperty(
    productForm,
    '_delivery_days_min',
    variantData.minBusinessDays
  );

  appendLineItemProperty(
    productForm,
    '_delivery_days_max',
    variantData.maxBusinessDays
  );

  appendLineItemProperty(
    productForm,
    '_promise_min_date',
    promiseRange.minDate.toISOString().slice(0, 10)
  );

  appendLineItemProperty(
    productForm,
    '_promise_max_date',
    promiseRange.maxDate.toISOString().slice(0, 10)
  );
}, true);

document.addEventListener('DOMContentLoaded', function() {
  updateKraveOosPromiseDisplay();

  setTimeout(updateKraveOosPromiseDisplay, 100);
  setTimeout(updateKraveOosPromiseDisplay, 300);

  document.addEventListener('change', function(event) {
    const isVariantChange =
      event.target.matches('input[type="radio"]') ||
      event.target.matches('select') ||
      event.target.matches('[name="id"]');

    if (!isVariantChange) {
      return;
    }

    setTimeout(updateKraveOosPromiseDisplay, 100);
    setTimeout(updateKraveOosPromiseDisplay, 300);
  });
});